import { eur } from "@/lib/apiClient";
import { BadgeEuro } from "lucide-react";

// Premio standard, sconto, importo sconto, premio convenzionato e risparmio (solo area riservata).
export const PrezzoConvenzionato = ({ r, testid = "prezzo" }) => (
  <div className="space-y-1.5 rounded-xl border border-terracotta/30 bg-terracotta/5 p-4 text-sm" data-testid={testid}>
    <div className="flex justify-between"><span className="text-muted-foreground">Premio standard</span><span className={r.sconto_importo > 0 ? "line-through decoration-1" : ""} data-testid={`${testid}-standard`}>{eur(r.premio_standard)}</span></div>
    {r.sconto_importo > 0 && <>
      <div className="flex justify-between"><span className="text-muted-foreground">Sconto accordo</span><span data-testid={`${testid}-pct`}>{Number(r.sconto_pct || 0).toLocaleString("it-IT")}%</span></div>
      <div className="flex justify-between"><span className="text-muted-foreground">Importo sconto</span><span data-testid={`${testid}-sconto`}>− {eur(r.sconto_importo)}</span></div>
    </>}
    <div className="flex items-baseline justify-between gap-3 border-t border-terracotta/20 pt-2">
      <span className="font-semibold text-forest">Premio convenzionato</span>
      <span className="font-heading text-2xl font-semibold text-forest" data-testid={`${testid}-convenzionato`}>{eur(r.premio_convenzionato)}</span>
    </div>
    {r.risparmio > 0 && (
      <div className="flex items-center gap-1.5 text-xs font-medium text-terracotta" data-testid={`${testid}-risparmio`}>
        <BadgeEuro className="h-4 w-4" /> Risparmi {eur(r.risparmio)} all'anno
      </div>
    )}
  </div>
);
